import { Chip, Tooltip } from '@material-ui/core'
import { Info } from '@material-ui/icons'
import TRANSLATE, { REGEXP } from 'utils/constants'

const WRONG_EMAIL_TEXT = 'Ingrese un correo electrónico válido'
const MASSIVE_USERS_ASSIGN_TOOLTIP_TEXT =
   'Activa esta opción para pegar varios correos a la vez. Si no debe consultar y seleccionar uno a uno del resultado obtenido'

const isEmail = email => Boolean(REGEXP.EMAIL.test(email))

const splitTextUsers = userText => userText?.split(' ')

const isMassiveUserValidation = (isMassiveUsersMode, formData) =>
   isMassiveUsersMode ? formData?.usersId?.some(email => !isEmail(email)) ?? '' : ''

const isMassiveUserErrorMessage = (isMassiveUsersMode, formData) => {
   let userIdErrorMessage = ''
   const validate = isMassiveUserValidation(isMassiveUsersMode, formData)
   if (!formData.usersId.length) userIdErrorMessage = TRANSLATE.FORM.SELECT_VALID_USER
   else if (validate) userIdErrorMessage = WRONG_EMAIL_TEXT
   return userIdErrorMessage
}

const RenderTags = (value, getTagProps) =>
   value.map((option, index) => {
      const item = option?.email ?? option
      return (
         <Chip
            label={item}
            {...getTagProps({ index })}
            key={item + index}
            color={isEmail(item) ? 'default' : 'secondary'}
         />
      )
   })

const MassiveAssignHelper = () => (
   <Tooltip arrow className="pointer" title={MASSIVE_USERS_ASSIGN_TOOLTIP_TEXT} placement="bottom-end">
      <Info />
   </Tooltip>
)

export default {
   MASSIVE_USERS_ASSIGN_TOOLTIP_TEXT,
   isEmail,
   splitTextUsers,
   isMassiveUserErrorMessage,
   RenderTags,
   MassiveAssignHelper
}
